/* ==========================================================================
    Google Maps handler
    - https://developers.google.com/maps/documentation/javascript/adding-a-google-map
 ========================================================================== */

const LocationMapHandler = {

    map: null,
    key: '',

    init: function () {
        LocationMapHandler.map = document.querySelector('.js-location-map')
        if (!isset(LocationMapHandler.map)) return;

        const mapMarkers = LocationMapHandler.map.querySelectorAll('.js-location-marker');

        for(let m = 0; m < mapMarkers.length; m++) {
            const mapMarker = mapMarkers[m];

            mapMarker.addEventListener('mouseover', function () {
                LocationMapHandler.enableBelongTooltip(this);
            });
            mapMarker.addEventListener('mouseout', function () {
                LocationMapHandler.disableBelongTooltip(this);
            });
        }

    },

    enableBelongTooltip: function (element) {
        const targetElement = LocationMapHandler.map.querySelector('#' + element.dataset.target);
        targetElement.classList.remove('is-hidden');
    },

    disableBelongTooltip: function (element) {
        const targetElement = LocationMapHandler.map.querySelector('#' + element.dataset.target);
        targetElement.classList.add('is-hidden');
    },


};

LocationMapHandler.init();